import { get, post, put, patch, postForm } from '@/shared/api/fetch-based-http-methods';
import { getApiUrl } from '@/shared/utils/getApiUrl';
import { w4dUserRemoteAPI } from '@src-common/api/definitions/w4d-user-endpoints';
import { TUser } from '@src-common/api/definitions/w4d-user-types';
import { createClient } from '@src-common/api/src/create-client';

import type { User } from '../model';

const client = createClient(
  w4dUserRemoteAPI({ apiHost: getApiUrl(), get, post, put, patch, postForm }),
);

const prepareUserData = (raw: TUser): User => ({
  userId: raw.id,
  firstName: raw.first_name,
  lastName: raw.last_name,
  middleName: raw.middle_name,
  cityId: raw.city_id,
  cityName: raw.city_name,
  partnerId: raw.partner_id,
  email: raw.email,
  source: raw.source || null,
  driverId: raw.driver_id ?? undefined,
  phone: raw.phone ?? 'hidden',
  roles: raw.roles ?? [],
});

const userAPI = {
  readUserData: async (): Promise<User> => {
    const response = await client.readUser();

    return prepareUserData(response.user);
  },
};

export { userAPI };
